// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import DataTable from "theme/Tables/DataTable";
import MDBadge from "theme/components/MDBadge";
import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";

function MyPayouts() {
  const pageTitle = "Transfers";
  usePageTitle(pageTitle);

  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [payouts, setPayouts] = useState([]);
  const [openTransferTypeDialog, setOpenTransferTypeDialog] = useState(false);

  function formatAmount(amount, currency) {
    const prefix = amount < 0 ? "-" : "";
    amount = Math.abs(amount);
    return `${prefix}${currency}${amount.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }

  const tableColumns = [
    { Header: "Currency", accessor: "currency", align: "left" },
    // { Header: "Income Source", accessor: "source", align: "center" },
    // { Header: "Beneficiary", accessor: "beneficiary", align: "left" },
    { Header: "Amount", accessor: "amount", align: "center" },
    { Header: "Fee", accessor: "fee", align: "center" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Created", accessor: "created", align: "right" },
  ];

  const buildRateRows = (data) => {
    const rows = [];
    data.map((payout) => {
      let statusColor = "warning";
      if (
        payout.status === "success" ||
        payout.status === "processed" ||
        payout.status === "completed"
      ) {
        statusColor = "success";
      } else if (payout.status === "failed") {
        statusColor = "error";
      } else {
        statusColor = "warning";
      }

      rows.push({
        currency: <b>{payout.currency.currency_code}</b>,
        // source: payout.income_source,
        // beneficiary:
        //   payout.beneficiary.beneficiary_type === "individual"
        //     ? `${payout.beneficiary.last_name} ${payout.beneficiary.first_name}`
        //     : payout.beneficiary.company_name,
        // beneficiary: payout.beneficiary_name,
        amount: formatAmount(payout.amount / 100, payout.currency.symbol),
        fee: formatAmount(payout.transaction_fee / 100, payout.currency.symbol),
        status: (
          <MDBadge badgeContent={payout.status} variant="contained" container color={statusColor} />
        ),
        created: payout.created,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("users/payouts.json")
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            const rows = buildRateRows(result.data.data.payouts);
            setPayouts(rows);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred. Make sure you have an active internet connection.");
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openTransferTypeDialog}>
        <DialogTitle>
          <MDBox>Transfer Destination</MDBox>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <MDBox>Please select a transfer destination</MDBox>
          </DialogContentText>
          <MDBox sx={{ marginTop: "15px", width: "100%" }}>
            <MDButton
              sx={{ minWidth: 120, width: "100%" }}
              color="dark"
              variant="outlined"
              onClick={() => {
                navigate("/transfers/transfer");
              }}
            >
              <Icon sx={{ fontWeight: "bold" }}>person</Icon>&nbsp; Alero Account &nbsp;
              <Icon sx={{ fontWeight: "bold" }}>chevron_right</Icon>
            </MDButton>
          </MDBox>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDButton
              sx={{ minWidth: 120, width: "100%" }}
              color="dark"
              variant="outlined"
              onClick={() => {
                navigate("/transfers/create");
              }}
            >
              <Icon sx={{ fontWeight: "bold" }}>account_balance</Icon>&nbsp; Bank Account &nbsp;
              <Icon sx={{ fontWeight: "bold" }}>chevron_right</Icon>
            </MDButton>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              setOpenTransferTypeDialog(false);
            }}
          >
            Cancel
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={3}>
                      <MDBox
                        pt={2}
                        px={2}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <MDTypography variant="h6" fontWeight="medium">
                          My Transfers
                        </MDTypography>
                        <MDButton
                          variant="contained"
                          color="dark"
                          onClick={() => {
                            // navigate("/payouts/create");
                            setOpenTransferTypeDialog(true);
                          }}
                        >
                          <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                          &nbsp;new transfer
                        </MDButton>
                      </MDBox>
                      <MDBox mt={5}>
                        <DataTable
                          table={{ columns: tableColumns, rows: payouts }}
                          isSorted={false}
                          entriesPerPage={false}
                          showTotalEntries={false}
                          noEndBorder
                        />
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default MyPayouts;
